import React from "react";
import { Box, Container, Typography, Link, IconButton, Grid } from "@mui/material"; 
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Reddit, Instagram } from "@mui/icons-material";

const Footer = () => {
  // Define social media links and their corresponding icons
  const socialLinks = [
    { icon: Reddit, url: "https://www.reddit.com/r/unitedintalk/" },
    { icon: Instagram, url: "https://www.instagram.com/arczen_official/" },
    { icon: TwitterIcon, url: "https://x.com/ArcZen_Official" },
    { icon: LinkedInIcon, url: "https://www.linkedin.com/company/arczen/?viewAsMember=true" },
    

  ];

  // Function to open links in a new tab
  const handleSocialClick = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (

  <Box sx={{paddingTop: '2rem'}}>
    <Box component="footer" sx={{ 
      bgcolor: 'light grey', 
      py: 4,
      borderTop: '1px solid rgba(71, 71, 71, 0.1)',
      width: '100%',
      //margin: 'auto',
      margin: 'left'
    }}>
      <Container maxWidth={'xl'}>
        <Grid container spacing={0} sx={{ margin: 'auto', justifyContent: 'center' }}>
          {/* Company branding */}
          <Grid item xs={6} md={3}> 
            <Box
              component="img"
              src="/UnitedInTalk_Logo_Flag.svg"
              alt="Logo"
              sx={{ height: '40px', mb: 2 }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Connect with fellow Americans and share diverse perspectives.
            </Typography>
          </Grid>
          
          {/* Links - First Column */}
          <Grid item xs={6} sm={6} md={3}> 
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Resources
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {[
                //{ label: 'Conversation Guides', url: 'https://example.com/guides' },
                //{ label: 'Political Education', url: 'https://example.com/education' },
                { label: 'Community Guidelines', url: '/guidelines' },
                { label: 'Terms of Service', url: '/terms' },
                { label: 'Privacy Policy', url: '/privacy' },
                { label: 'Blog', url: 'https://explore.unitedintalk.com/blog' },
                
                
              ].map((item) => (
                <Box component="li" key={item.label} sx={{ mb: 1 }}>
                  <Link 
                    href={item.url} 
                    color="text.secondary" 
                    underline="hover"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.label}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Links - First Column */}
          <Grid item xs={6} sm={6} md={3}> 
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Links
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {[
                { label: 'About', url: 'https://explore.unitedintalk.com/about' },
                { label: 'Contact', url: 'https://explore.unitedintalk.com/contact' },
                { label: 'Meet the Developers', url: 'https://arczen.com' }
                
              ].map((item) => (
                <Box component="li" key={item.label} sx={{ mb: 1 }}>
                  <Link 
                    href={item.url} 
                    color="text.secondary" 
                    underline="hover"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.label}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>
          
          {/* Social Links */}
          <Grid item xs={6} sm={6} md={3}> 
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Follow Us
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {socialLinks.map((social, i) => {
                const Icon = social.icon;
                return (
                  <IconButton 
                    key={i}
                    onClick={() => handleSocialClick(social.url)}
                    aria-label={`Visit our ${social.url.split('.com/')[1]} page`}
                    sx={{ 
                      border: '1px solid rgba(0,0,0,0.1)',
                      '&:hover': { 
                        bgcolor: 'primary.main', 
                        color: 'white',
                        cursor: 'pointer' 
                      }
                    }}
                  >
                    <Icon fontSize="small" />
                  </IconButton>
                );
              })}
            </Box>
            <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
              &copy; {new Date().getFullYear()} UnitedInTalk
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
    </Box>
  );
};

export default Footer;